/**
 * Форматирует число как валюту в формате USD
 */
export const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
};

